export type ChannelCommand = {
    name: string;
    args?: string;
    description: string;
};

export const CHANNEL_COMMANDS: ChannelCommand[] = [
    { name: "help", description: "Liste les commandes disponibles" },
    { name: "ping", description: "Pong ! Teste la réactivité du bot" },
    {
        name: "kick",
        args: "<@user> [raison]",
        description: "Exclut un membre du serveur",
    },
    {
        name: "ban",
        args: "<@user> [raison]",
        description: "Bannit un membre du serveur",
    },
    {
        name: "mute",
        args: "<@user> <durée>",
        description: "Rend muet un membre (ex: 30m, 2h, 1d, 1w)",
    },
    {
        name: "warn",
        args: "<@user> [raison]",
        description: "Ajoute un avertissement (auto-sanction selon warn_config)",
    },
    {
        name: "warn_config",
        description: "Configure les 3 slots de sanctions (menu dans les paramètres du serveur)",
    },
    {
        name: "clear",
        args: "[nb]",
        description: "Supprime les derniers messages du salon (défaut 10, max 100)",
    },
    {
        name: "lock",
        description: "Verrouille le salon (lecture seule pour tout le monde)",
    },
    {
        name: "unlock",
        description: "Déverrouille le salon",
    },
];
